import { createElement } from 'dom-helper';
import deparam from 'node-jquery-deparam';
import { GWITracker } from 'gwi-tracker';
import Modal from './modal';
import Logger from '../utils/logger';
import YouTubePlayer from './youtube-player';

export default class TrailerModal extends Modal {

  static showTrailer(trackingState, trailerUrl, trackingOptions = {}) {
    const anchor = createElement('a');
    anchor.href = trailerUrl;

    const queryParams = deparam(anchor.search.substring(1));

    Logger.debug('Parsed query params from trailerUrl', trailerUrl, 'with:', queryParams);

    if (queryParams.v) {
      Logger.debug('Found YouTube param, loading video with id', queryParams.v);

      const trailerId = '__gwi-youtube-player';
      const iFrameHtml = `<div id="${trailerId}"></div>`;

      TrailerModal.show(iFrameHtml);

      YouTubePlayer.display(trailerId, queryParams.v, {
        onEnd: time => GWITracker.trackTrailerEnd(
            trackingState,
            time,
            trackingOptions,
        ),
        onPause: time => GWITracker.trackTrailerPause(
            trackingState,
            time,
            trackingOptions,
        ),
        onPlay: time => GWITracker.trackTrailerPlay(
            trackingState,
            time,
            trackingOptions,
        ),
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/trailer-modal.js